module.exports = __webpack_public_path__ + "img/369.29f48369.jpg";